import { useState, useEffect } from "react"
import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import NavbarAuth from '../components/NavbarAuth';
import Footer from '../components/Footer';
import axios from "axios";
import NicmlProductList from "../components/NicmlProducts";
import NslProductList from "../components/NslProducts";
import Navbar from "../components/Navbar";


const Products = () => {

    return (
        <>  
            <NavbarAuth />
            <section className="mt-5">
                <div className="container pt-5">
                    <div className="row">
                        <div className="col-12">
                            <NicmlProductList/>
                        </div>
                        
                        <div className="col-12 mt-5">
                            <NslProductList/>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default Products;
